import React from 'react'
import CameraIcon from '../../elements/icons/CameraIcon'
import { Link } from 'react-router-dom'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import { calculateAge } from '../../../utils'

const StudentCardHorizontal = ({student}) => {
  return (
    <div className='w-full flex items-stretch justify-between gap-x-[10px] bg-white p-[10px] rounded-[8px]'>
      <div className='w-[75px]'>
        <div className='bg-gray-50 h-[75px] w-[75px] rounded-[8px] flex items-center justify-center' style={{
          backgroundImage: `url(" ${student.passportPhotograph} ")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'none'
          }}>
            {(!student.passportPhotograph || student.passportPhotograph === '') &&
                <CameraIcon className={`w-8 h-8 text-gray-400`} />
            }
        </div>
      </div>
      <div className='w-full'>
          <p className='font-space-grotesk text-sm font-[550]'>{`${student.lastName}, ${student.firstName}${student.otherNames ? ` ${student.otherNames} ` : ' '}`}</p>
          <p className='text-sm text-gray-500'>{calculateAge(student?.dob)} year old, {student?.gender?.toLowerCase()}</p>
          <Link to={`/admin/students/student/${student?._id}`} className='mt-[3px] flex flex-row items-center gap-x-1 text-vcm-purple hover:text-gray-400 transition duration-200 text-xs'>
              See student details <ArrowIcon className={`w-3 h-3`} />
          </Link>
      </div>
    </div>
  )
}

export default StudentCardHorizontal